import React from 'react';

interface LandingFooterProps {
    phoneNumber?: string;
    availability?: string;
    formUrl: string;
}

const LandingFooter: React.FC<LandingFooterProps> = ({
    formUrl,
}) => {
    return (
        <footer className="bg-productCard py-16 px-6 mt-16">
            <div className="max-w-4xl mx-auto text-center space-y-6">
                <h2 className="text-2xl sm:text-3xl font-bold text-textColor">
                    Bereit, Nahversorgung neu zu denken?
                </h2>
                <h3 className="text-xl sm:text-2xl font-semibold text-textColor">
                    Yobsti bringt mehr als nur Lebensmittel – wir bringen ein Stück Lebensqualität zurück.
                </h3>

                <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                    Für Ihre Bürger:innen. Für die Region. Für die Zukunft des ländlichen Raums. <br />
                    Ob kleine Ortsgemeinde oder wachsender Stadtrand – wir machen aus Versorgung eine Herzensangelegenheit. Gemeinsam mit Ihnen.
                </p>

                <div className="pt-4 space-y-4">
                    <a
                        href={formUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-lineGreen text-white font-semibold px-6 py-3 rounded-full shadow hover:bg-primaryDark transition"
                    >
                        Jetzt unverbindlich Standort prüfen lassen
                    </a>

                    {/* <div className="space-y-2">
                        <p className="text-gray-700">Oder:</p>
                        <a
                            href=""
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block bg-lineGreen text-white font-semibold px-6 py-3 rounded-full shadow hover:bg-primaryDark transition"
                        >
                            Infopaket für Gemeinden herunterladen (PDF)
                        </a>
                    </div> */}
                </div>

                <div className="pt-8 space-y-2">
                    <p className="text-gray-700 font-bold">
                        Sie möchten einen bestehenden Yobsti besuchen?
                    </p>
                    <p className="text-gray-700">
                        Gerne organisieren wir eine Besichtigung – einfach im Formular angeben.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
